/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */

// import * as actions from '../actions/initializeValues';
// import { demoShipments } from '../util/demoShipments'
// import { dummyDataContainerInfo, coors } from '../util/testJSON'
// import { shipmentListData, shipmentActivityDetail, shipmentsCurrentLocation } from '../data/shipmentData'
import {
  saveActorName,
  saveActorAddress,
  saveImporterAddressAndName,
  saveHeaderParties,
  saveHeaderPartiesByHeaderId,
  saveConsigneeAddressAndName
} from '../api/setFormData'

const initialState = {
  // initialValues
}

export default function ImporterReducer(state = initialState, action) {
  let chosenParty = null;
  let headerPartyType = "";
  let headerPartiesCopy = "";
  let stateCopy = JSON.parse(JSON.stringify(state));
  if (state?.headerParties) {
    headerPartiesCopy = JSON.parse(JSON.stringify(state.headerParties));
    chosenParty = headerPartiesCopy.find(aaa => aaa.headerId == action.headerPartyIndex);
    if (chosenParty) {
      headerPartyType = chosenParty.headerPartyType;

    } else if (stateCopy.importer.importerId == action.headerPartyIndex) {
      chosenParty = stateCopy.importer;
      headerPartyType = "importer";
    } else if (stateCopy.consignee.consigneeId == action.headerPartyIndex) {
      chosenParty = stateCopy.consignee;
      headerPartyType = "consignee";
    }
  }
  switch (action.type) {
    case 'INITIALIZE_VALUES_IMPORTER': {
      return Object.assign({}, state, { ...action.payload })
    }
    case 'UPDATE_ACTOR_FIELD': {
      if(!chosenParty)return state;
      
      if(action.field=="idnumber" || action.field=="idtype"){
        if(headerPartyType == "importer"){
          chosenParty.importerIdInfo = chosenParty.importerIdInfo||{}
          chosenParty.importerIdInfo[action.field] =action.payload || " "
        } else {
          chosenParty.consigneeIdInfo = chosenParty.consigneeIdInfo||{}
          chosenParty.consigneeIdInfo[action.field] =action.payload || " ";

        }
      } else {
        chosenParty[action.field] = action.payload
      }
      if(headerPartyType == "importer"){
        return Object.assign({}, state, { importer: chosenParty })
      }
      if(headerPartyType == "consignee"){
        return Object.assign({}, state, { consignee: chosenParty })
      }
      return Object.assign({}, state, { headerParties: headerPartiesCopy })
    }
    case 'UPDATE_ACTOR_ADDRESS': {
      if(!chosenParty)return state;
      let headerPartiesCopy = state.headerParties.slice()
      chosenParty.addressInfo[action.field] = action.payload
      
      if(headerPartyType == "importer"){
        return Object.assign({}, stateCopy, { importer: chosenParty })
      }
      if(headerPartyType == "consignee"){
        return Object.assign({}, stateCopy, { consignee: chosenParty })
      }
      return Object.assign({}, state, { headerParties: headerPartiesCopy })
    }
    case 'ADD_HEADER_ITEM_PARTY': {
      // field: Array(1)
      // 0:
      // actorid: "1654250401"
      // mid: "HKHONYAZ348WAN"
      // name: "New Manufacturer 5"
      // type: "MANUFACTURER"
      let headerParties = state.headerParties.slice()
      for(let newheaderparty of (action.field ||[])){
        let nodupes=true;
        if(!newheaderparty.headerPartyType)newheaderparty.headerPartyType = newheaderparty.type;
        if(!newheaderparty.headerId)newheaderparty.headerId = newheaderparty.actorid;
        if(!newheaderparty.mId)newheaderparty.mId = newheaderparty.mid;
        if(!newheaderparty.addressInfo)newheaderparty.addressInfo={}
        newheaderparty.newheaderpartything = true;
        for(let oldheaderparty of headerParties){
          if(oldheaderparty.headerId == newheaderparty.actorid)nodupes=false;
        }
        if(nodupes){
          headerParties.push(newheaderparty);
        }
      }

      return Object.assign({}, state, { headerParties })
    }
    case 'REMOVE_HEADER_ITEM_PARTY': {
      let headerParties = state.headerParties.slice()
      //let headerParties = JSON.parse(JSON.stringify(state.headerParties))
      headerParties = headerParties.filter((a)=>a.headerId!=action.field)
      return Object.assign({}, state, { headerParties })
    }
    case 'UPDATE_HEADER_PARTY_FIELD': {
      
      if(!chosenParty)return state;
      let headerPartiesCopy = state.headerParties.slice()
      chosenParty[action.field] = action.payload
      if(headerPartyType == "importer"){
        return Object.assign({}, stateCopy, { importer: chosenParty })
      } else if(headerPartyType == "consignee"){
        return Object.assign({}, stateCopy, { consignee: chosenParty })
      } else {
        headerPartiesCopy.map((item)=>{
         if(item.headerId == action.headerPartyIndex){
          item[action.field] = action.payload
         }
        })
        return Object.assign({}, state, { headerParties: headerPartiesCopy })
      }

    }
    case 'UPDATE_HEADER_PARTY': {
      let headerParties = state.headerParties.slice();
      if(!chosenParty)
      return Object.assign({}, state, { headerParties })
        
      if (action.sameAs === 'Importer') {
        chosenParty.name = state?.importer?.name ||""
        chosenParty.importerIdInfo = Object.assign({}, state.importer.importerIdInfo)
        chosenParty.addressInfo = state?.importer?.addressInfo || chosenParty.addressInfo
      } else {
        const reqParty = headerParties.find(
          party => party.headerPartyType.toLowerCase() === action.sameAs.toLowerCase()
        )
        chosenParty.name = reqParty.name
        chosenParty.addressInfo = Object.assign({}, reqParty.addressInfo) || chosenParty.addressInfo
      }
      return Object.assign({}, state, { headerParties })
    }
    case 'UPDATE_HEADER_PARTY_ADDRESS': {
      let headerParties =  state.headerParties.slice()
      let chosenParty = headerParties.find(aaa=>aaa.headerId == action.headerPartyIndex);
      if(chosenParty){
        chosenParty.addressInfo[action.field] = action.payload
        return Object.assign({}, state, { headerParties: headerParties })
      } else if(state.importer.importerId == action.headerPartyIndex){
        chosenParty = state.importer;
        chosenParty.addressInfo[action.field] = action.payload
        return Object.assign({}, state, { importer: chosenParty })
      } else if(state.consignee.consigneeId == action.headerPartyIndex){
        chosenParty = state.consignee;
        chosenParty.addressInfo[action.field] = action.payload
        return Object.assign({}, state, { consignee: chosenParty })
      }

      return state;
    }
    case 'ADD_HEADER_PARTY': {
      let newHeaderParty = {
        headerPartyType: '',
        name: '',
        addressInfo: {
          STREET_NAME: '',
          CITY: '',
          COUNTRY_SUB_ENTITY: '',
          POSTAL_CODE: '',
          COUNTRY: ''
        },
        headerId: ''
      }
      let headerParties = state.headerParties.slice()
      headerParties.push(newHeaderParty)
      return Object.assign({}, state, { headerParties })
    }

    case 'ADD_MANUFACTURER': {
      let newHeaderParties = state.headerParties.slice()
      newHeaderParties.push(action.newManufacturer)
      return Object.assign({}, state, { headerParties: newHeaderParties })
    }

    case 'REMOVE_HEADER_PARTY': {
      let headerParties = state.headerParties
        .slice(0, action.payload)
        .concat(state.headerParties.slice(action.payload + 1))
      saveHeaderParties(headerParties, -1)
      return Object.assign({}, state, { headerParties })
    }
    case 'UPDATE_FIELD': {
      return Object.assign({}, state, { [action.field]: action.payload })
    }
    // Save Data
    case 'SAVE_IMPORTER': {
      saveImporterAddressAndName(
        state.importer.name,
        state.importer.addressInfo,
        state.importer.importerId,
        state.importer
      )
      return state
    }
    case 'SAVE_CONSIGNEE': {
      saveConsigneeAddressAndName(state.consignee)
      return state
    }
    case 'SAVE_HEADER_PARTIES': {
      saveHeaderPartiesByHeaderId(state.headerParties, action.headerPartyIndex)
      return state
    }
    case 'SAVE_HEADER_PARTIES_BY_HEADER_ID': {
      saveHeaderPartiesByHeaderId(state.headerParties, action.headerId)
      return state
    }
    case 'INITIALIZE_SHIPID': {
      return Object.assign({}, state, { shipId: action.payload })
    }
    default:
      return state
  }
}
